import { render, staticRenderFns } from "./tunjangan.vue?vue&type=template&id=3c5a4be3"
import script from "./tunjangan.vue?vue&type=script&lang=js"
export * from "./tunjangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports